import type { StaticLayerPayload } from "@config";
import { TickerLibrary, TickerPdf } from "@library-elements/ticker";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: TickerLibrary,
  pdf: TickerPdf,
};

export const Ticker = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
